import { fabric } from 'fabric';
import DEFINE from '../define';
import ToolBase from '../basic';
import { focusStore } from '../../store/nowFocusStore';

export default class PolygonTool extends ToolBase {

    name = DEFINE.TOOLS.POLYGON_TOOL;

    originPosition = new fabric.Point(600, 550);

    // 多邊形工具
    polygon_tool = null;

    //輸入參數
    value = null;

    constructor(parent) {
        super(parent);
    }

    create() {
        super.create();

        const self = this;

        this.originPosition.x = focusStore.mainBookPage.pagePercentPoint.x * this.parent.canvas.width;
        this.originPosition.y = focusStore.mainBookPage.pagePercentPoint.y * this.parent.canvas.height;

        let value = this.value;

        const angle = 360 / value;
        const radius = 100;  //預設半徑

        //四邊形要特別旋轉成正方形角度，其餘旋轉成起點在正上方
        let rotateAngle = value == 4 ? 45 : 90;

        let pointArray = [];

        for (let i = 0; i < value; i++) {
            //弧度
            let radian = (i * angle - rotateAngle) * Math.PI / 180;

            //計算新的x, y座標
            let x = radius * Math.cos(radian);
            let y = radius * Math.sin(radian);

            pointArray.push({ x: x, y: y });
        }

        self.polygon_tool = new fabric.Polygon(pointArray, {
            tag: DEFINE.TAG.POLYGON_TOOL + new Date().getTime(),
            toolType: self.name,
            left: self.originPosition.x,
            top: self.originPosition.y,
            fill: DEFINE.COLOR.TRANSPARENT,
            stroke: DEFINE.COLOR.MATH_TOOL.BLACK_0_0_0,
            strokeWidth: 5,
            originX: "center",
            originY: "center",
            transparentCorners: false,
            cornerColor: DEFINE.COLOR.CORNER_COLOR,
            selectable: true,
        });

        self.setControls(self.polygon_tool);

        self.canvas.add(self.polygon_tool);
        self.canvas.renderAll();
    }

    setValue(value) {
        super.setValue(value);
        this.value = value;
    }

    recover(object) {
        let tag = object.tag;

        if (tag.includes(DEFINE.TAG.POLYGON_TOOL)) {
            this.polygon_tool = object;

            this.setControls(object);
        }
    }

    setControls(object) {
        object.set({
            hasBorders: false,
            controls: Object.assign(this.getBasicControls(), {
                mtr: this.getTouchRotateControl({
                    x: 0.5,
                    y: 0,
                    offsetX: 25,
                    offsetY: 0,
                }),
                deleteControl: this.getDeleteControl({
                    x: 0.5,
                    y: -0.5,
                    offsetX: 25,
                    offsetY: 0,
                }),
            })
        });
    }

    mouseUp(o) {
        this.parent.changeTool(null);
    }
}